import { FC } from 'react';

import { useToggle } from '@hooks';
import { useTranslate } from '@i18n';
import { Box, Button, u } from '@ui';

import { ModuleBase } from '../ModuleBase';

import { LiveAnalysisActiveParameters } from './LiveAnalysisActiveParameters';
import { LiveAnalysisSettingsModal } from './LiveAnalysisModal';
import { LiveAnalysisTable } from './LiveAnalysisTable';
import { LiveAnalysisControls } from './LiveAnalysisTableControls';
import * as styles from './styles.css';

type LiveAnalysisModuleProps = {
    readOnly?: boolean;
};

export const LiveAnalysisContent: FC<LiveAnalysisModuleProps> = ({ readOnly }) => {
    const [settingsOpen, toggleSettingsOpen] = useToggle();

    return (
        <>
            <Box px={u(3)}>
                <Box className={styles.moduleContent}>
                    {!readOnly && (
                        <Box display="flex" gap={u(1)}>
                            <Button variant="secondary" onClick={() => toggleSettingsOpen()} icon="goal" rounded>
                                {'Setup Live'}
                            </Button>
                        </Box>
                    )}
                    {!readOnly && <LiveAnalysisActiveParameters />}
                    {!readOnly && <LiveAnalysisControls />}
                    <LiveAnalysisTable />
                </Box>
            </Box>
            {settingsOpen && !readOnly && <LiveAnalysisSettingsModal onDismiss={() => toggleSettingsOpen(false)} />}
        </>
    );
};

export const LiveAnalysisModule: FC<LiveAnalysisModuleProps> = ({ readOnly = false }) => {
    const t = useTranslate();
    const [settingsOpen, toggleSettingsOpen] = useToggle();

    return (
        <>
            <ModuleBase title={t('module.live_analysis')} isClosed={false}>
                <Box className={styles.moduleContent}>
                    {!readOnly && <LiveAnalysisActiveParameters />}
                    {!readOnly && <LiveAnalysisControls />}

                    <LiveAnalysisTable />
                </Box>
            </ModuleBase>

            {settingsOpen && !readOnly && <LiveAnalysisSettingsModal onDismiss={() => toggleSettingsOpen(false)} />}
        </>
    );
};
